import { memo } from 'react';
import { Handle, Position } from '@xyflow/react';

/**
 * Get icon for different symbol kinds
 */
function getKindIcon(kind) {
  switch (kind?.toLowerCase()) {
    case 'class':
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="3" width="18" height="18" rx="2"/>
          <path d="M3 9h18"/>
        </svg>
      );
    case 'method':
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="10"/>
          <path d="M12 6v6l4 2"/>
        </svg>
      );
    case 'interface':
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M12 2L2 7l10 5 10-5-10-5z"/>
          <path d="M2 17l10 5 10-5"/>
          <path d="M2 12l10 5 10-5"/>
        </svg>
      );
    default: // function
      return (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"/>
        </svg>
      );
  }
}

/**
 * Custom node for functions/methods in the call graph
 */
function FunctionNode({ data, selected }) {
  const kindClass = data.kind ? `kind-${data.kind.toLowerCase()}` : '';
  const directionClass = data.direction ? `direction-${data.direction}` : '';
  const rootClass = data.isRoot ? 'is-root' : '';

  return (
    <div className={`graph-node function-node ${kindClass} ${directionClass} ${rootClass} ${selected ? 'selected' : ''}`}>
      <Handle type="target" position={Position.Top} />
      <div className="node-icon">
        {getKindIcon(data.kind)}
      </div>
      <div className="node-content">
        <div className="node-label">{data.label}</div>
        {data.signature && <div className="node-signature">{data.signature}</div>}
        {data.fileName && (
          <div className="node-file">
            {data.fileName.split('/').pop()}
          </div>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} />
    </div>
  );
}

export default memo(FunctionNode);
